<!-- Translated: yes -->
<template>
  <Modal @close="localClose" :wide="false" width="940px">
    <img :src="'https://static.booking.branasgruppen.se/static/img/bjorn.svg'" class="high-five" />
    <h1>{{ $t('general.highfive') }}</h1>

    <p v-html="message"></p>


    <!--<button v-if="ref === 'accomodation'" @click="goTo('/boenden')" class="orange">Jag vill lägga till fler boenden</button>
    <button v-if="ref === 'skischool'" @click="goTo('/skidskola')" class="orange">Jag vill boka fler skidskolor</button>
    <button v-if="ref === 'skirental'" @click="goTo('/skidhyra/oversikt?add-more=1'')" class="orange">Jag vill hyra mer utrustning</button>
    <button v-if="ref === 'skipass'" @click="goTo('/liftkort')" class="orange">Jag vill lägga till fler liftkort</button>-->
    <button @click="localClose()">{{ $t('general.go-to-cart') }}</button>

    <h2>{{ $t('general.cart-upsell-title') }}</h2>
    <CompletedBookings style="margin-top:10px;" />

    <SkiRentalDiscount click-link="/skidhyra" />
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import CompletedBookings from '@/components/parts/CompletedBookings';
import SkiRentalDiscount from '@/components/components/SkiRentalDiscount';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CompletedBookings,
    SkiRentalDiscount,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
    message() {
      if (this.ref === 'skischool') {
        return this.$i18n.t('general.cart-confirmation.skischool');
      } else if (this.ref === 'bikeschool') {
        return 'Nu är din cykelskola vald och ligger i varukorgen!';
      } else if (this.ref === 'accomodation') {
        return this.$i18n.t('general.cart-confirmation.accomodation');
      } else if (this.ref === 'skirental') {
        return this.$i18n.t('general.cart-confirmation.skirental');
      } else if (this.ref === 'skipass') {
        return this.$i18n.t('general.cart-confirmation.skipass');
      } else if (this.ref === 'activity') {
        return this.$i18n.t('general.cart-confirmation.activity');
      } else if (this.ref === 'product') {
        return `Nu finns <b>${this.params.text}</b> i varukorgen!`;
      }
      return '';
    },
    ref() {
      return this.params.ref;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
    ]),
    localClose() {
      this.closeModal();
      this.$router.replace('/varukorg');
    },
    goTo(path) {
      this.closeModal();
      this.$router.push({ path });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.discount-offer
  text-align: left;

.high-five
  margin-bottom 15px

button
  margin-left: 10px
  margin-right: 10px
  margin-top: 10px
  font-size: 12px
  margin-bottom: 10px

h1
  font-size: 30px;
  font-weight: 900;
  margin-bottom 5px

h2
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  margin-top 30px
  margin-bottom: 20px
  united-heavy()
  +max-mobile()
    font-size: 20px

.modalo
  text-align center
</style>



// WEBPACK FOOTER //
// CartHighFiveModal.vue?2b717422